import React from 'react';
import classNames from 'classnames';
import styles from './Rating.module.scss';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import { Phrases } from '../../../utilities/constants/phrases';
import Icon, { IconGlyph } from '../../Icon';

const Rating: React.FC = () => (
  <div className={classNames(styles.rating)}>
    <p className='text-sm fw-medium c-main-light d-flex flex-jc-c flex-ai-c gap-xxxxxs'>
      {renderTextWithIndexedTags(Phrases.RATING, [
        <Icon
          glyph={IconGlyph.STAR}
          key='element-0'
        />,
        <span
          key='element-1'
          className='c-main'
        />,
        <span
          key='element-2'
          className='c-main'
        />,
      ])}
    </p>
  </div>
);

export default Rating;
